import * as React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link, useNavigate } from "react-router-dom";

// redux
import { useSelector, useDispatch } from 'react-redux';
import WebService from '@util/webService';
import { getAction, printVariable } from '@util/helper';
import { setSchola } from '@redux/actions/scholaAction';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';

import '@scss/App.scss'
import { isAdmin } from '@util/helper';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import { setAccount } from '@redux/actions/accountAction';
import { useTheme } from '@mui/material/styles';
import {GlobalStyle as gs} from '@src/GlobalStyle'
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { makeStyles } from '@mui/styles';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { useMediaQuery } from "@mui/material";
import { setCodes } from "@redux/actions/codeAction";

const useStyles = makeStyles({
  helpTitle: {
    backgroundColor: gs.colors.main,
    color: gs.colors.cardBg,
    alignItems: "center",
    borderRadius: 5,
    justifyContent: "center",
    display: "flex",
  },

  helpContent: {
    backgroundColor: gs.colors.cardBg,
    color: gs.colors.main,
    alignItems: "flexStart",
    borderRadius: 5,
    justifyContent: "flexStart",
    display: "flex",
    flexDirection:'column',
    padding:20,
    width:'100',
  }
});


const helpMessages = [
  {
    role:'repManager', 
    tips:[
      "설정에서 '회사 등록' 및 '위탁 대상 학교'를 신청 진행 해 주세요.",
      "설정의 '매니저 현황' 에서 매니저를 학교에 배정할 수 있습니다.", 
    ]
  },
  {
    role:'manager', 
    tips:[
      "설정의 '매니저 일터' 에서 매니저 등록 신청을 해 주세요.",
    ]
  },
  {
    role:'teacher', 
    tips:[
      "설정 또는 모바일 앱에서 '출강 학교' 에서 강사 등록 신청을 해 주세요.",
      "방과후 학습 관련해서는 모바일 앱을 사용해 주세요.",
    ]
  },
  {
    role:'gdn', 
    tips:[
      "학생 보호자님은 학생이 학교에 제출한 보호자님 휴대폰 전화 번호로 자동 매칭됩니다.",
      "방과후 학습 관련해서는 모바일 앱을 사용해 주세요.",
    ]
  },

]
const HelpContent = ({content}) => {
  return(
    <Typography variant='body2' sx={{display:'flex', alignItems:'center', fontWeight:'bold', margin:1}}>
      <TaskAltIcon sx={{mr:1, fontSize:16}} />
        {content}
    </Typography>
  )
}
const ManagerIndexPage = () => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const [managerSchools, set_managerSchools] = useState([])
  const [directSchools, set_directSchools] = useState([])
  const [lectureSchools, set_lectureSchools] = useState([])
  const [gdnSchools, set_gdnSchools] = useState([])
  const theme = useTheme()
  const [loaded, set_loaded] = useState(false)
  const classes = useStyles()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const onClickSchool = async (schola, origin) => {
    const url = `/smst/active/${schola.id}`
    const resp = await WebService.get(url, {})


    // TODO, calendar 와 중복
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const smst = JSON.parse(repMessage.smst)
      schola.smst = smst
    }
    else {
      schola.smst = {id: -1}
    }
    
    dispatch(setSchola(schola))

    if(origin === 'manager') {
      navigate('/manager')
    }
    else if(origin === 'teacher') {
      navigate('/teacher')
    }
    else if(origin === 'gdn') {
      navigate('/gdn')
    }
  }

  const fetchCodes = async() => {
    const url = '/code'
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records  = JSON.parse(repMessage.records)
      dispatch(setCodes(records))
    }
  }

  const onLoad = async() => {
    const newAccount = await fetchAccount()
    dispatch(setAccount(newAccount))
    const gdnSchools = await fetchGdnSchools()
    set_gdnSchools(gdnSchools)

    // console.log('newAccount.schoolRelationList=>', newAccount.schoolRelationList)
    const managerSchools = newAccount.schoolRelationList.filter(r => r.rltnCode === 'S004').map(it => it.school)
    // 서버에서 솟팅해서 보내오므로 아래 라인 불필요.
    set_managerSchools(managerSchools)

    const directSchools = newAccount.schoolRelationList.filter(r => r.rltnCode === 'S001').map(it => it.school)
    directSchools.sort((a,b) => a.name.localeCompare(b.name))
    set_directSchools(directSchools)

    const lectureSchools = newAccount.schoolRelationList.filter(r => r.rltnCode === 'S003').map(it => it.school)
    lectureSchools.sort((a,b) => a.name.localeCompare(b.name))
    set_lectureSchools(lectureSchools)
    
    await fetchCodes()

    set_loaded(true)
  }

  const fetchAccount = async() => {
    const url =`/user/refresh/${account.user.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const newAccount = JSON.parse(repMessage.account)
      return newAccount
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }

  const fetchGdnSchools = async () => {
    const url = `/school/gdn/id/${account.user.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      return records
    }
    else {
      openSnackbar(resp.repMessage)
    }
  }
  
  useEffect(() => {
    onLoad()
  },[])

  return (
    <>
      {
        loaded ? (
          <Box sx={{ minHeight: "50vh", display: "flex", flexGrow: 1, justifyContent: "center", alignItems: "center", flexDirection:'column', padding:isMobile ? 0: 10 }}>
            <Grid container spacing={2} >
              <Grid item xs={12}>
                <Box style={{marginBottom:40}}>
                  <Typography variant={isMobile ? 'h6' : 'h4'} align='center' color={gs.colors.bar} sx={{fontWeight:isMobile ? 'bold' : 'normal'}}>
                    스쿨매니저에 오신 것을 환영합니다 !
                  </Typography>
                </Box>
              </Grid>
                {isAdmin(account) ? (
                  <Grid item xs={12}>
                    <div>
                      <div>
                        <Typography style={{ display: "flex", alignItems: "center", cursor: "pointer", color:'#512da8' }} variant='h3' onClick={() => navigate("/admin")}>
                          <AdminPanelSettingsOutlinedIcon align='center' /> &nbsp;시스템어드민
                        </Typography>
                      </div>
                    </div>
                  </Grid>
                ) : null}

              {/*위탁업체 대상학교 */}
              {
                managerSchools.length > 0 ? (
                  <Grid item xs={12}>
                    <Typography align='center' variant='h6' style={{ borderBottom: "1px solid #ccc" }}>
                      위탁 대상 학교 목록
                    </Typography>
                  </Grid>
                ) : null
              }
              {
                managerSchools.length > 0 && (
                  managerSchools.map((it, index) => (
                    <Grid key={index} item xs={12} sm={3} sx={{ cursor: "pointer" }}>
                      <Card
                        variant='outlined'
                        style={{ backgroundColor: gs.colors.cardBg, color: theme.palette.primary.main}}
                        onClick={(e) => {
                          onClickSchool(it, "manager")
                        }}>
                        <CardContent>
                          <Typography variant='h5' sx={{ color: theme.palette.primary.main, fontWeight: "bold" }} align='center'>
                            {it.name}
                          </Typography>
                          <Typography variant='body2' sx={{ mt: 1.5 }}>
                            {it.newZipCode}
                            <br />
                            {it.newAddr1}
                          </Typography>
                          <Typography sx={{ mt: 1.5 }} st={{ color: theme.palette.primary.main }}>
                            {it.phone}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                )
              }
              {
                directSchools.length > 0 ? (
                  <Grid item xs={12}>
                    <Typography align='center' variant='h6' style={{ borderBottom: "1px solid #ccc" }}>
                      직영 학교 목록
                    </Typography>
                  </Grid>
                ) : null
              }
              {
                directSchools.length > 0 && (
                  directSchools.map((it, index) => (
                    <Grid key={index} item xs={12} sm={3} sx={{ cursor: "pointer" }}>
                      <Card
                        variant='outlined'
                        style={{ backgroundColor: gs.colors.cardBg, color: theme.palette.primary.main}}
                        onClick={(e) => {
                          onClickSchool(it, "manager")
                        }}>
                        <CardContent>
                          <Typography variant='h5' sx={{ color: theme.palette.primary.main, fontWeight: "bold" }} align='center'>
                            {it.name}
                          </Typography>
                          <Typography variant='body2' sx={{ mt: 1.5 }}>
                            {it.newZipCode}
                            <br />
                            {it.newAddr1}
                          </Typography>
                          <Typography sx={{ mt: 1.5 }} st={{ color: theme.palette.primary.main }}>
                            {it.phone}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                )
              }


              {/* 출강학교 */}
              
              {
                lectureSchools.length > 0 ? (
                  <>
                    <Grid item xs={12}>
                      <Typography align='center' variant='h6' style={{ borderBottom: "1px solid #ccc" }}>
                        출강 학교 목록
                      </Typography>
                      
                    </Grid>
                    <Grid item xs={12}>
                      <Typography align='center' color={theme.palette.error.main}>
                        공용 PC 에서 사용 후에는 보안을 위하여 반드시 로그아웃 하여 주시기 바랍니다.
                      </Typography>
                    </Grid>
                  </>
                ) : null
              }
              {
                lectureSchools.length > 0 && (
                  lectureSchools.map((it, index) => (
                    <Grid key={index} item xs={12} sm={3} sx={{ cursor: "pointer" }}>
                      <Card
                        variant='outlined'
                        style={{ backgroundColor: gs.colors.cardBg, color: theme.palette.primary.main}}
                        onClick={(e) => {
                          onClickSchool(it, "teacher")
                        }}>
                        <CardContent>
                          <Typography variant='h5' sx={{ color: theme.palette.primary.main, fontWeight: "bold" }} align='center'>
                            {it.name}
                          </Typography>
                          <Typography variant='body2' sx={{ mt: 1.5 }}>
                            {it.newZipCode}
                            <br />
                            {it.newAddr1}
                          </Typography>
                          <Typography sx={{ mt: 1.5 }} st={{ color: theme.palette.primary.main }}>
                            {it.phone}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                )
              }

              {/* 보호자 학교 */}
              {
                gdnSchools.length > 0 ? (
                  <>
                    <Grid item xs={12}>
                      <Typography align='center' variant='h6' style={{ borderBottom: "1px solid #ccc" }}>
                        우리 아이 학교 목록
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Typography variant='body' align='center'>
                          모바일 앱으로 로그인 후 확인 가능합니다.
                        </Typography>
                      </div>
                    </Grid>
                  </>
                ) :  null
              }
            </Grid>
             {
                managerSchools.length == 0 && directSchools.length == 0 && lectureSchools.length == 0 && gdnSchools.length == 0 && (
                  <>
                  <Grid container spacing={1} >
                    {/* 대표 */}
                    <Grid item xs={12} sm={3} sx={{display:'flex'}}>
                        <div className={classes.helpTitle} style={{width:'100%'}}>
                          <Typography variant='h6' sx={{fontWeight:'bold'}}>회사대표(매니저)님</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={9} sx={{display:'flex',}} >
                        <div className={classes.helpContent} style={{flexDirection:'column', width:'100%'}}>
                          {
                            helpMessages
                              .filter(r => r.role === 'repManager')
                              .flatMap(r => r.tips)
                              .map((item, index) => (
                                <HelpContent key={index} content={item} />  
                              ))
                          }
                        </div>
                    </Grid>

                    {/*  매니저  */}
                    <Grid item xs={12} sm={3} sx={{display:'flex'}}>
                        <div className={classes.helpTitle} style={{width:'100%'}}>
                          <Typography variant='h6' sx={{fontWeight:'bold'}}>매니저(코디)님</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={9} sx={{display:'flex'}} >
                        <div className={classes.helpContent} style={{flexDirection:'column',  width:'100%'}}>
                          {
                            helpMessages
                              .filter(r => r.role === 'manager')
                              .flatMap(r => r.tips)
                              .map((item, index) => (
                                <HelpContent key={index} content={item} />  
                              ))
                          }
                        </div>
                    </Grid>
                    {/*  강사  */}
                    <Grid item xs={12} sm={3} sx={{display:'flex'}}>
                        <div className={classes.helpTitle} style={{width:'100%'}}>
                          <Typography variant='h6' sx={{fontWeight:'bold'}}>강사님</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={9} sx={{display:'flex'}} >
                        <div className={classes.helpContent} style={{flexDirection:'column',  width:'100%'}}>
                          {
                            helpMessages
                              .filter(r => r.role === 'teacher')
                              .flatMap(r => r.tips)
                              .map((item, index) => (
                                <HelpContent key={index} content={item} />  
                              ))
                          }
                        </div>
                    </Grid>

                    {/*  보호자   */}
                    <Grid item xs={12} sm={3} sx={{display:'flex'}}>
                        <div className={classes.helpTitle} style={{width:'100%'}}>
                          <Typography variant='h6' sx={{fontWeight:'bold'}}>보호자님</Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={9} sx={{display:'flex'}} >
                        <div className={classes.helpContent} style={{flexDirection:'column',  width:'100%'}}>
                          {
                            helpMessages
                              .filter(r => r.role === 'gdn')
                              .flatMap(r => r.tips)
                              .map((item, index) => (
                                <HelpContent key={index} content={item} />  
                              ))
                          }
                        </div>
                    </Grid>
                  </Grid>
                  </>
                )
              }
          </Box>
        ): null
      }

      {renderIndicator()}
    </>
	)
}

export default ManagerIndexPage
